import api, { unwrap } from './client';

export async function listAssessments(params = {}) {
  return unwrap(await api.get('/admin/assessments', { params }));
}

export async function getAssessment(id) {
  return unwrap(await api.get(`/admin/assessments/${id}`));
}

export async function exportAssessmentsCsv(params = {}) {
  const res = await api.get('/admin/assessments/export.csv', {
    params,
    responseType: 'blob',
  });
  return res.data;
}

export async function deleteAssessment(id) {
  return unwrap(await api.delete(`/admin/assessments/${id}`));
}
